<template>
  <div class="w-full">
    <n-select :options="options" :onchange="onCategoryChange" border>
    </n-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "components.insurances.new.step-category",
  props: {
    claimType: String,
    customerTemplate: String,
    contractAmount: Number
  },
  data: () => ({
    category: null
  }),
  computed: {
    ...mapGetters({
      categories: "insurance/getCategories"
    }),
    options() {
      let options = [
        { value: null, key: this.$t("insurances.new.category.placeholder") }
      ];
      this.categories.forEach(element => {
        options.push({
          value: element.code,
          key: element.name
        });
      });
      return options;
    }
  },
  methods: {
    onCategoryChange(e) {
      const device = this.categories.find(
        category => category.code === e.target.value
      );
      this.selectDevice(device);
    },
    selectDevice(category) {
      this.category = category;
      if (this.category != null) {
        this.$parent.$parent.setCollapsed(true);
      }
    }
  },
  watch: {
    category(n) {
      this.$parent.$parent.$emit("dataChange", n);
      this.$parent.$parent.$emit("pickedChange", n != null ? n.name : "");
    },
    customerTemplate() {
      this.$store.dispatch("insurance/getCategories", {
        template: this.customerTemplate,
        contract_amount: this.contractAmount
      });
    }
  },
  created() {
    this.$store.dispatch("insurance/getCategories", {
      template: this.customerTemplate,
      contract_amount: this.contractAmount
    });

    if (this.categories && this.categories.length === 1) {
      this.selectDevice(this.categories[0]);
    }
  }
};
</script>
